import React, { useState, useEffect } from "react";
import { getRequest } from "../../../utils/httpRequest";
import WalletCard from "./WalletCard";
import DebitCard from "./DebitCard";
import "./index.scss";
import { t } from "../../../utils/i18n";

const MainWalletCard = ({
  walletId,
  current_user,
  debitCardId,
  canActivateCard,
}) => {
  const [walletData, setWalletData] = useState(null);

  const fetchWalletData = async () => {
    try {
      const data = await getRequest("/api/v1/dashboard/accounts");
      setWalletData(data);
    } catch (error) {
      console.error("Error fetching wallet data:", error);
    }
  };

  useEffect(() => {
    fetchWalletData();
  }, []);

  return (
    <div className="card-wallets">
      <WalletCard
        walletData={walletData?.wallet_balances?.account_balance}
        cardBg="bg-white"
        footerBg="bg-white"
        footerLinks={{
          [t("home.wallet_card.add_funds")]: "/add_funds",
          [t("home.wallet_card.send_payments")]: "/send_usd#SendPaymentsModal",
          [t("home.wallet_card.view_all_assets")]: `/wallets/${walletId}`,
        }}
        refreshWalletData={fetchWalletData}
        className=""
      />
      <WalletCard
        walletData={walletData?.wallet_balances?.p2p_escrow_balance}
        cardBg="bg-orange"
        footerBg="bg-white"
        footerLinks={{
          [t("home.wallet_card.create_offer")]: "/p2p_trades/offers/new?offer_type=buy",
          [t("home.wallet_card.trade_usd")]: "/p2p_trades/offers/search?offer_type=buy",
          [t("home.wallet_card.view_all_trades")]: "/p2p_trades/trades",
        }}
        refreshWalletData={fetchWalletData}
        className=""
      />
      <DebitCard
        currentUser={current_user}
        cardId={debitCardId}
        canActivateCard={canActivateCard}
      />
      <WalletCard
        walletData={walletData?.wallet_balances?.crypto_asset_balance}
        cardBg="bg-purple"
        footerBg="bg-orange"
        footerLinks={{
          [t("home.wallet_card.send_token")]: "/crypto_transfers/send_crypto/new",
          [t("home.wallet_card.receive_token")]: `/wallets/${walletId}/wallet_addresses`,
          [t("home.wallet_card.see_more")]: `/wallets/${walletId}`,
        }}
        refreshWalletData={fetchWalletData}
        className="kai-os-hide"
      />
    </div>
  );
};

export default MainWalletCard;
